const ScrollMagic = require('scrollmagic');
// DO NOT REMOVE THIS COMMENTED OUT CODE PLEASE.
// UNCOMMENT TO SEE INDICATORS FOR WHERE SCROLL EVENTS ARE TRIGGERED FOR SCROLL MAGIC
// require('../../../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js');

import generateFullHref from '../utils/generate_full_href';
import generateUrl from '../utils/generate_url_with_slide_util';
import trackOmniture from '../utils/track_omniture';


class Scroller {
    /**
     * The Scroller class is where we manage scrolling in the mobile photo gallery, keeping track of which slide is currently in view and updating the URL accordingly.
     * @param  {object} config props for $slides, slideIndexParam, offset
     * @return {obj} instance of Scroller
     */
    constructor(config) {
        this.controller = new ScrollMagic.Controller({ container: `.photo-gallery__modal[data-url="${config.slideShowUrl}"]` });
        this.counter = 0;
        this.scenes = [];
        this.$slides = config.$slides;
        this.slideIndexParam = config.slideIndexParam;
        this.offset = config.offset;
    }

    // Create the ScrollMagic scene
    createScene(config) {
        const scene = new ScrollMagic.Scene(config)
        // DO NOT REMOVE THIS COMMENTED OUT CODE PLEASE.
        // UNCOMMENT TO SEE INDICATORS FOR WHERE SCROLL EVENTS ARE TRIGGERED FOR SCROLL MAGIC
        // .addIndicators({name: `${++this.counter}: (duration: ${config.duration})`})
        .addTo(this.controller);
        this.scenes.push(scene);
        return scene;
    }
    destroy() {
        this.scenes.forEach((scene) => {
            scene.destroy();
        });
        this.controller.destroy(true);
        this.scenes = null;
        this.controller = null;
    }

    // Make each slide a ScrollMagic scene
    turnSlidesIntoScenes() {
        this.$slides.each(function (index, item) {
            let slideNumber = index + 1;
            let slideHeight = $(item).height();
            let sceneOffset = $(item).offset().top;
            // see here for playing around with config http://scrollmagic.io/examples/basic/scene_manipulation.html
            const configForScroll = {
                triggerElement: '.js-photo-gallery__modal__slide-' + slideNumber,
                triggerHook: 0.66,
                offset: this.offset,
                duration: slideHeight,
                reverse: true
            };
            let scene = this.createScene(configForScroll);
            scene.slideNumber = slideNumber;
            scene.slideIndex = index;
            scene.offset = sceneOffset;
            scene.on('enter', function (e) {
                // Upon entering a slide/scene, derive its slide number from its index and add that number as a slide parameter to the URL
                let slideIndex = e.currentTarget ? e.currentTarget.slideIndex : 1;
                let originalUrl = window.location.pathname;
                window.history.replaceState(null, '', generateFullHref(generateUrl(originalUrl, slideIndex)));
            });

        }.bind(this));

        if (this.slideIndexParam) {
            this.controller.scrollTo(function (newScrollPos, callback) {
                $(this).animate({scrollTop: newScrollPos}, 0, "swing", function () {
                    setTimeout(callback, 0);
                });
            });

            this.controller.scrollTo(this.scenes[this.slideIndexParam].offset - 30, function () {
                this.scenes.forEach(function (scene) {
                    scene.on('enter', function (e) {
                        // Upon entering a slide/scene, derive its slide number from its index and add that number as a slide parameter to the URL
                        let slideIndex = e.currentTarget ? e.currentTarget.slideIndex : 1;
                        const slideNum = slideIndex + 1;

                        if (e.scrollDirection === 'REVERSE') {
                            trackOmniture('event30', slideNum);
                        }
                        if (e.scrollDirection === 'FORWARD') {
                            trackOmniture('event29', slideNum);
                        }
                    });
                });
            }.bind(this));

        }
    }
}

export default Scroller;
